import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicStyleLoaderService {

  constructor() { }
  
  loadStyles(styleUrls: string[]): Promise<void> {
    return Promise.all(
      styleUrls.map(styleUrl => {
        return new Promise<void>((resolve, reject) => {
          // Check if the stylesheet is already loaded
          if (document.querySelector(`link[href="${styleUrl}"]`)) {
            resolve();
            return;
          }
  
          // Create a new link element for the stylesheet
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = styleUrl;
  
          // Resolve the promise when the stylesheet is loaded
          link.onload = () => resolve();
  
          // Reject the promise if there's an error loading the stylesheet
          link.onerror = () => reject(new Error(`Failed to load stylesheet: ${styleUrl}`));
  
          // Append the link element to the document head
          document.head.appendChild(link);
        });
      })
    ).then(() => {
    });
  }
}
